import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@mui/material/Tooltip'

import CheckBox from '@components/inputs/checkBox'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '@components/loading'
import 'material-icons/iconfont/filled.css'

import {
  Container,
  Title,
  CloseIcon,
  CheckBoxContainer,
  InfoContainer,
  InfoIcon,
  ModalContainer,
  Text,
} from './styles'

const DownloadPdfModal = ({
  isOpen,
  setClose,
  hasLaboratoryExam,
  hasAcceptedTerms,
  mergeTermsOfConsent,
  mergeLaboratoryExams,
  onChangeTermsOfConsent,
  onChangeLaboratoryExams,
  onSubmit,
  loading,
}) => {

  const selected = () => {
    if (mergeTermsOfConsent && mergeLaboratoryExams) return 'Todos os campos'
    if (mergeTermsOfConsent) return 'Termo de consentimento'
    if (mergeLaboratoryExams) return 'Exames laboratoriais'
    return 'Nenhuma opção selecionada'
  }
  return (
    <ModalContainer isOpen={isOpen} onRequestClose={setClose}>
      <CloseIcon className="material-icons" onClick={setClose}>close</CloseIcon>
      <Container>
        <Title>Exportar PDF</Title>
        <Text>Selecione quais documentos você deseja exportar junto:</Text>
        <CheckBoxContainer>
          <CheckBox locked label="Relatório de saúde preventiva" />
          <InfoContainer>
            <CheckBox
              isInaccessible={!hasAcceptedTerms}
              locked={!hasAcceptedTerms}
              checked={mergeTermsOfConsent}
              onChange={onChangeTermsOfConsent}
              label="Termo de consentimento"
            />
            {!hasAcceptedTerms && (
            <Tooltip title="Não assinado." arrow>
              <InfoIcon />
            </Tooltip>
            )}
          </InfoContainer>
          <InfoContainer>
            <CheckBox
              isInaccessible={!hasLaboratoryExam}
              locked={!hasLaboratoryExam}
              checked={mergeLaboratoryExams}
              onChange={onChangeLaboratoryExams}
              label="Exames laboratoriais"
            />
            {!hasLaboratoryExam && (
            <Tooltip title="Não coletado." arrow placement="top">
              <InfoIcon className="material-icons">info</InfoIcon>
            </Tooltip>
            )}
          </InfoContainer>
        </CheckBoxContainer>
        <PrimaryButton style={{ marginTop: 24 }} onClick={() => onSubmit(selected)}>
          {loading ? (
            <Loading
              color="#fff"
              height={30}
              width={30}
            />
          ) : 'Exportar'}
        </PrimaryButton>
      </Container>
    </ModalContainer>
  )
}

DownloadPdfModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func,
  hasAcceptedTerms: PropTypes.bool,
  hasLaboratoryExam: PropTypes.bool,
  mergeTermsOfConsent: PropTypes.bool,
  mergeLaboratoryExams: PropTypes.bool,
  onChangeTermsOfConsent: PropTypes.func,
  onChangeLaboratoryExams: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

DownloadPdfModal.defaultProps = {
  isOpen: false,
  setClose: () => {},
  hasAcceptedTerms: false,
  hasLaboratoryExam: false,
  mergeTermsOfConsent: false,
  mergeLaboratoryExams: false,
  onChangeTermsOfConsent: () => {},
  onChangeLaboratoryExams: () => {},
  loading: false
}

export default DownloadPdfModal
